import script from "./ContactDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ContactDetail.vue?vue&type=style&index=0&id=38ee4529&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ee4529"]])

export default __exports__